export default function AboutSection() {
  return (
    <div id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <div className="inline-block bg-red-100 text-red-600 px-4 py-2 rounded-full text-sm font-bold mb-6">
              ABOUT THE WARRIORS
            </div>
            <h2 className="text-5xl font-black text-gray-900 mb-6 leading-tight">
              Tri-State Warriors
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Embark on a journey with the Tri-State Warriors, where grit meets glory on the gridiron. Our saga is one of relentless determination, unity, and the unwavering spirit of warriors that resonates with every play.
            </p>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              We're not just a team; we're a legacy in motion, pushing the boundaries of the sport and inspiring a new generation of fans. Celebrate our victories, learn from our challenges, and see why we stand as titans in the realm of women's football.
            </p>
            <a
              href="#about-full"
              className="inline-block bg-red-600 text-white px-8 py-4 rounded-lg text-base font-bold hover:bg-red-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Learn More About Us
            </a>
          </div>

          {/* Right Content - Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://tristatewarriors.com/wp-content/uploads/2024/02/test-alfa.png"
                alt="Tri-State Warriors Team"
                className="w-full h-auto object-cover"
              />
            </div>
            {/* Decorative Element */}
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-red-600 rounded-2xl -z-10"></div>
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-gray-900 rounded-2xl -z-10"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
